import { type MotifComponent, type MotifComponentProps, m } from '../../motif';
import { heroLightBgVars } from './Hero.palette';

export const snapHeroPrimaryVars: MotifComponentProps<MotifComponent.HERO> = {
  ...heroLightBgVars,
  '--hero-text-color-curtain-active': m('--neutral-v700'),
  '--hero-content-desktop-padding': `${m('--spacing-xl')} 0px ${m('--spacing-xl')} ${m(
    '--spacing-m'
  )}`,
} as const;
